import { createAction, props } from '@ngrx/store';
import { DownloadLeaseAgreementData } from '../../interfaces/download-lease-agreement';

export const LoadDownloadLeaseAgreementAction = createAction(
    '[Download Lease Agreement] Load Download Lease Agreement'
);

export const DownloadLeaseAgreementDataSuccessAction = createAction(
    `[Download Lease Agreement Success] Download Lease Agreement Data Success`,
    props<{ data: DownloadLeaseAgreementData }>()
);

export const DownloadLeaseAgreementDataError = createAction(
    `[Download Lease Agreement Error] Download Lease Agreement Data Error`,
    props<{ error: string }>()
);

export const resetDownloadLeaseAgreementData = createAction(
    `[Download Lease Agreement] reset Download Lease Data`,
);